import React from 'react';
import './ui.css';

/**
 * Button
 * Props:
 *   variant   — 'primary' | 'secondary' | 'outline'  (default: 'primary')
 *   size      — 'sm' | 'md' | 'lg'                    (default: 'md')
 *   href      — renders as <a> if provided
 *   onClick   — click handler
 *   children  — button label
 *   className — extra class names
 *   target    — for anchor tags
 */
function Button({
  variant = 'primary',
  size = 'md',
  href,
  onClick,
  children,
  className = '',
  target,
  rel,
  ...props
}) {
  const classes = `btn btn--${variant} btn--${size} ${className}`;

  if (href) {
    return (
      <a
        href={href}
        className={classes}
        target={target}
        rel={rel}
        {...props}
      >
        {children}
      </a>
    );
  }

  return (
    <button className={classes} onClick={onClick} {...props}>
      {children}
    </button>
  );
}

export default Button;